import { createGlobalStyle } from 'styled-components';

import primaryFont from '../assets/fonts/CevicheOne-Regular.ttf';
import secondaryFont from '../assets/fonts/HammersmithOne-Regular.ttf';

const Typography = createGlobalStyle`
    @font-face {
        font-family: CevicheOne;
        src: url(${primaryFont});
        font-display: block;
    }

    @font-face {
        font-family: HammersmithOne;
        src: url(${secondaryFont});
        font-display: block;
    }

    html {
        font-size: 62.5%;
        font-family: CevicheOne;
        color: var(--black);
    }

    body {
        line-height: 1.6;
        font-size: 2.5rem;
        letter-spacing: .1rem;
    }

    p {
        font-family: HammersmithOne;
        font-size: 1.6rem;
    }

    h4{
        font-family: HammersmithOne;
    }

    button,
    .button {
        font-family: HammersmithOne;
    }

    .cart-item-count {
        font-family: CevicheOne;
    }

    // TODO: clean this up
    footer p {
        font-family: CevicheOne;
        font-size: 2.5rem;
    }
`;

export default Typography;